
import TiwiMixin from '../mixins/TiwiMixin'


export default {
  mixins: [ TiwiMixin ],
  props: {
    activities: {
      type: Array,
      required: true,
    }
  },
  data() {
		return {

		}
	},
  mounted: () => {
		// Eseguito al mount
	},
  computed: {
   
  },
  methods: {

  },
}
